import NoDataComponent from "./../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const foreign_labor_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Foreign Labor Recruiters"
      subheaderinfo="Foreign Labor Recruiters will appear here"
    />
  );
};

export default foreign_labor_no_data;